import { getActiveFileUploadsCount, getIncompleteUploadsCount } from '@tabeeb/modules/fileUploads/selectors'

import {
  Analytics,
  Assignment,
  Ballot,
  Chat,
  CloudUpload,
  Collections,
  Delete,
  FactCheck,
  FormatBold,
  Group,
  Link,
  LocalOfferOutlined,
  PersonPinCircle,
  School,
  Search,
  Share,
  ThreeDRotation,
  ThreeSixty,
  Videocam,
  ViewInAr,
} from '@mui/icons-material'

import { getIsClassificationAnnotationsPagesTimelineOpen } from '@tabeeb/modules/classificationAnnotationsPagesTimeline/selectors'
import { getUnreadTrainingMaterialsCount } from '@tabeeb/modules/articles/selectors'
import { getTotalUnreadMessagesCount } from '@tabeeb/modules/chat/selectors'
import { getIsTrainingMaterialsEnabled } from '@tabeeb/modules/appConfigState/selectors'
import { getIsTimelineOpen as getIsSplatTimelineOpen } from '@tabeeb/modules/splatModel/selectors'

import { TabPanel, TabPanelLocation } from '@tabeeb/enums'

import { RootState } from '@tabeeb/store'
import {
  showChatTab,
  showSelectedPagesForMergingTab,
  showActivitiesTab,
  showLinkedContentsTab,
  showCustomVideoTab,
  showSpatialViewTab,
  showThreeDimensionalModelTab,
  showShareSessionTab,
  showReviewSessionTab,
  showBentleyModelTab,
  showBentleyAnalyticsReportTab,
  showFileUploadsTab,
  showContentReviewsTab,
  showCheckInTab,
} from '../selectors'

export const TabPanelLocationGroups: Record<TabPanelLocation, TabPanel[]> = {
  [TabPanelLocation.Left]: [
    TabPanel.Forms,
    TabPanel.Chat,
    TabPanel.Activities,
    TabPanel.LinkedContents,
    TabPanel.ContentTrainingMaterials,
    TabPanel.CheckIns,
    TabPanel.ContentReviews,
  ],
  [TabPanelLocation.Bottom]: [
    TabPanel.Users,
    TabPanel.CustomVideo,
    TabPanel.ShareSession,
    TabPanel.ReviewSession,
    TabPanel.SpatialView,
    TabPanel.ThreeDModel,
    TabPanel.SplatModel,
    TabPanel.BentleyModel,
    TabPanel.BentleyAnalyticsReport,
    TabPanel.LinkedContentsSelectedPages,
    TabPanel.ClassificationAnnotations,
  ],
  [TabPanelLocation.Right]: [TabPanel.Gallery, TabPanel.FileUploads, TabPanel.TrashBin],
}

export const ReadonlyTabPanelLocationGroups: Record<TabPanelLocation, TabPanel[]> = {
  [TabPanelLocation.Left]: [TabPanel.Forms],
  [TabPanelLocation.Bottom]: [],
  [TabPanelLocation.Right]: [TabPanel.Gallery],
}

export const ExpandableSessionTabs = [TabPanel.Gallery, TabPanel.FileUploads, TabPanel.CheckIns]

export const TabBubbleSelectors: Partial<Record<TabPanel, (state: RootState, props: { contentId: number }) => number>> =
  {
    [TabPanel.Chat]: getTotalUnreadMessagesCount,
    [TabPanel.ContentTrainingMaterials]: getUnreadTrainingMaterialsCount,
    [TabPanel.FileUploads]: getActiveFileUploadsCount,
  }

export const TabIcons: Record<TabPanel, JSX.Element> = {
  [TabPanel.Forms]: <Assignment />,
  [TabPanel.Chat]: <Chat />,
  [TabPanel.Activities]: <Search />,
  [TabPanel.LinkedContents]: <Share />,
  [TabPanel.ContentTrainingMaterials]: <School />,
  [TabPanel.CheckIns]: <PersonPinCircle />,
  [TabPanel.ContentReviews]: <FactCheck />,
  [TabPanel.Users]: <Group />,
  [TabPanel.CustomVideo]: <Videocam />,
  [TabPanel.SpatialView]: <ThreeSixty />,
  [TabPanel.ThreeDModel]: <ThreeDRotation />,
  [TabPanel.ShareSession]: <Share />,
  [TabPanel.ReviewSession]: <Ballot />,
  [TabPanel.BentleyModel]: <FormatBold />,
  [TabPanel.SplatModel]: <ViewInAr />,
  [TabPanel.BentleyAnalyticsReport]: <Analytics />,
  // eslint-disable-next-line jsx-a11y/anchor-is-valid
  [TabPanel.LinkedContentsSelectedPages]: <Link />,
  [TabPanel.FileUploads]: <CloudUpload />,
  [TabPanel.Gallery]: <Collections />,
  [TabPanel.TrashBin]: <Delete />,
  [TabPanel.ClassificationAnnotations]: <LocalOfferOutlined />,
}

export const isTabVisibleSelectors: Record<TabPanel, (state: RootState) => boolean> = {
  [TabPanel.Forms]: () => true,
  [TabPanel.Chat]: showChatTab,
  [TabPanel.Activities]: showActivitiesTab,
  [TabPanel.LinkedContents]: showLinkedContentsTab,
  [TabPanel.ContentTrainingMaterials]: getIsTrainingMaterialsEnabled,
  [TabPanel.CheckIns]: showCheckInTab,
  [TabPanel.ContentReviews]: showContentReviewsTab,
  [TabPanel.Users]: () => true,
  [TabPanel.CustomVideo]: showCustomVideoTab,
  [TabPanel.SpatialView]: showSpatialViewTab,
  [TabPanel.ThreeDModel]: showThreeDimensionalModelTab,
  [TabPanel.ShareSession]: showShareSessionTab,
  [TabPanel.ReviewSession]: showReviewSessionTab,
  [TabPanel.BentleyModel]: showBentleyModelTab,
  [TabPanel.SplatModel]: getIsSplatTimelineOpen,
  [TabPanel.BentleyAnalyticsReport]: showBentleyAnalyticsReportTab,
  [TabPanel.LinkedContentsSelectedPages]: showSelectedPagesForMergingTab,
  [TabPanel.ClassificationAnnotations]: getIsClassificationAnnotationsPagesTimelineOpen,
  [TabPanel.Gallery]: () => true,
  [TabPanel.FileUploads]: showFileUploadsTab,
  [TabPanel.TrashBin]: () => true,
}

export const isTabInProgressSelectors: Partial<Record<TabPanel, (state: RootState) => boolean>> = {
  [TabPanel.FileUploads]: getIncompleteUploadsCount,
}
